module.exports = __webpack_public_path__ + "assets/img/mtTitle-71bcd27a.png";